<template>
    <b-modal
        :visible="isOpen"
        @hidden="close"
        :lazy="true"
        title-tag="h2"
        title="Assign Lab"
    >
        <!-- TODO : add warning message, ref: patient_labLresul.php -->
        <b-row class="d-flex align-items-center form-item">
            <b-col cols="2">
                <b>Lab:</b>
            </b-col>
            <!-- <b-col v-html="record ? properTestName(record) : ''">
            </b-col> -->
            <b-col>
                {{ labTestName }}
            </b-col>
        </b-row>

        <b-row class="d-flex align-items-center form-item">
            <b-col cols="2">
                <b>Patient:</b>
            </b-col>
            <b-col>
                <v-select
                    v-model="selectedPatient"
                    @search="fetchPatients"
                    placeholder="Select patient (required)"
                    :noDrop="isDisableDropPatient"
                    :options="patientListOptions"
                >
                    <template v-slot:no-options="{ search }">
                        <span class="no-result"
                            >No result for "{{ search }}"</span
                        >
                    </template>
                </v-select>
            </b-col>
        </b-row>

        <b-row class="d-flex align-items-center form-item">
            <b-col cols="2">
                <b>Record:</b>
            </b-col>
            <b-col>
                <b-form-select
                    v-model="labSource"
                    :disabled="selectedPatient === null"
                    :options="labSourceOptions"
                ></b-form-select>
            </b-col>
        </b-row>

        <template v-slot:modal-footer>
            <div v-if="isLoading" class="preloader">
                <img src="assets/ajax-loader.gif" />
            </div>

            <b-button
                class="mr-auto"
                variant="secondary"
                @click="close"
                v-if="!isLoading"
            >
                Cancel
            </b-button>

            <b-button
                v-if="!isLoading && labSource === '1'"
                variant="primary"
                @click="next"
            >
                Next
            </b-button>
            <b-button
                v-else-if="!isLoading"
                variant="primary"
                @click="assign"
                :disabled="labSource === '0'"
            >
                Assign
            </b-button>
        </template>

        <modal-record
            ref="modalRecord"
            :hideBackdrop="true"
            @onSuccess="onSuccessModalRecord"
        />
    </b-modal>
</template>

<script>
//TODO: fetch records + apply to dropdown select

import vSelect from "vue-select";
import { debounce } from "lodash";
import modalRecord from "@/module/commons/record/create-update";

const defaultLabSourceOptions = [
    {
        value: "0",
        text: "Select source of lab (required)"
    },
    {
        value: "1",
        text: "Create new record"
    }
];

export default {
    components: {
        vSelect,
        modalRecord
    },
    props: {
        reloadAfter: {
            type: Boolean
        }
    },
    data() {
        return {
            isOpen: false,
            isLoading: false,
            selectedPatient: null,
            patientListOptions: [],
            isDisableDropPatient: true,
            patientId: null,
            patientIndex: null,
            patientName: null,
            labResultId: null,
            labTestName: null,
            businessId: null,
            labSource: "0",
            moduleName: null,
            labSourceOptions: [],
            record: null,
            labNameId: null
        };
    },
    watch: {
        selectedPatient(value) {
            if (value) {
                if (this.labNameId) {
                    let labId = this.labNameId.toUpperCase();

                    if (labId === "ZOETIS") {
                        // record_zoetis_fuse
                        this.getRecordZoetis();
                    } else {
                        // record_abaxis
                        this.getRecordAbaxis();
                    }
                }
            }
        }
    },
    methods: {
        open({
            labTestName,
            businessId,
            patientId,
            patientIndex,
            labResultId,
            patientName,
            moduleName,
            record
        }) {
            this.isOpen = true;
            this.record = record;
            this.businessId = businessId;
            this.patientName = patientName;
            this.patientId = patientId;
            this.patientIndex = patientIndex;
            this.labResultId = labResultId;
            // this.labTestName = labTestName;
            this.moduleName = moduleName;

            // auto-select patient (if any)
            if (patientName && patientIndex && patientId) {
                this.selectedPatient = {
                    label: `${patientName} (${patientIndex})`,
                    id: patientId,
                    index: patientIndex,
                    value: patientId
                };
            }

            this.getRecordList();
        },
        close() {
            this.isOpen = false;
        },
        async getRecordList() {
            let type = this.record.module;
            const res = await this.$http.get(
                process.env.BARRAMUNDI + "lab/patient",
                {
                    params: {
                        id: this.record.id,
                        type
                    }
                }
            );
            const resources = res.data.response.resources;

            switch (type) {
                case "onprem":
                    this.processOnprem(resources);
                    break;
                case "abaxis_api":
                    this.processAbaxisApi(resources);
                    break;
                case "lab":
                    // this.processOnprem();
                    break;
                case "idexx":
                case "znlabs":
                case "midwest":
                case "nbiovet":
                case "vetek":
                case "microvet":
                case "bionote":
                case "heska_cloud":
                    // this.processOnprem();
                    break;
                case "antech":
                    // this.processOnprem();
                    break;
            }

            // const resources = res.data.response.resources;
        },
        processOnprem(result) {
            if (result.item && result.item.display_name) {
                this.labTestName = result.item.display_name;
            } else {
                let name = result.product_info_rotor_name
                    ? result.product_info_rotor_name
                    : result.analyzer_type;
                this.labTestName = result.source + ": " + name;
            }

            const { options, patient_record } = result;

            if (options) {
                let filteredRecordIds = [];
                let result = [];

                for (const recordId in patient_record) {
                    if (patient_record[recordId] === this.patientId) {
                        filteredRecordIds.push(recordId);
                    }
                }

                for (const key of filteredRecordIds) {
                    result.push({
                        value: key,
                        text: options[key]
                    });
                }

                this.labSourceOptions = [...defaultLabSourceOptions, ...result];
            } else {
                this.labSourceOptions = defaultLabSourceOptions;
            }
        },
        processAbaxisApi(result) {
            //zoetis n non-zoetis
            this.labTestName = result.item.display_name;
            this.labNameId = result.laboratory_id;
        },
        getRecordZoetis(patientId) {},
        getRecordAbaxis(patientId) {},
        next() {
            this.$refs.modalRecord.open({
                action: "new",
                patient: {
                    id: this.selectedPatient.id
                },
                hideSendToLab: true
            });
        },
        assign(type) {
            switch (type) {
                case "onprem":
                    // PATIENT.save_patient_lab();
                    break;
                case "abaxis_api":
                    // zoetis , PATIENT.save_patient_lab_result();
                    // non zoetis , PATIENT.save_patient_lab_result();
                    break;
                case "lab":
                    // PATIENT.save_unassigned_lab_result();
                    break;
                case "idexx":
                case "znlabs":
                case "midwest":
                case "nbiovet":
                case "vetek":
                case "microvet":
                case "bionote":
                case "heska_cloud":
                    // PATIENT.save_unassigned_lab_result();
                    break;
                case "antech":
                    // PATIENT.save_patient_antech();
                    break;
            }
        },
        fetchPatients(search) {
            this.searchPatients(search, this);
        },
        searchPatients: debounce(async (search, self) => {
            if (search === "") {
                return;
            }

            const res = await self.$http.get(
                `${process.env.BARRAMUNDI}patient/search-patient`,
                {
                    params: {
                        query: search
                    }
                }
            );

            const { message, resources } = res.data.response;

            if (message.code === 200) {
                self.patientListOptions = self.generatePatientList(resources);
                self.isDisableDropPatient = false;
            } else {
                self.patientListOptions = [];
            }
        }, 350),
        generatePatientList(records = []) {
            let result = [];

            for (const patient of records) {
                result.push({
                    label: `${patient.fullname} (${patient.index})`,
                    id: patient.id,
                    index: patient.index,
                    value: patient.id
                });
            }

            return result;
        },
        onSuccessModalRecord() {
            //TODO : assign();
            this.close();
        }
    }
};
</script>

<style scoped>
.preloader {
    margin: 8px 0;
}
.form-item {
    margin-bottom: 10px;
}
span.no-result {
    margin-left: 10px;
}
</style>
